exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-dept-tree-v2 .tree-scroll-wrap{height:100% !important;overflow:auto !important}.yxtbiz-dept-tree-v2 .yxt-scrollbar{height:100% !important}.yxtbiz-base-tree-node{display:inline-block}\n", ""]);

